import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export default function Link({children, ...props}) {
  return (
    <RouterLink
    {...props}
    className={twMerge("flex-grow font-bold text-violet-200  hover:text-violet-300 duration-200 hover:underline", props?.className)}
    >
      {children}
    </RouterLink>
  );
}
